
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 2.667c.589 0 1.066.477 1.066 1.066v3.2h3.2a1.067 1.067 0 010 2.134h-3.2v3.2a1.067 1.067 0 11-2.133 0v-3.2h-3.2a1.067 1.067 0 010-2.134h3.2v-3.2c0-.589.478-1.066 1.067-1.066z","fill":"#A0AEC0"}})])
          )
        }
      }
    